var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"domainListAccordion",staticClass:"domain-list accordion",attrs:{"data-accordion":"","data-allow-all-closed":"true","data-multi-expand":"true"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }